import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import CancelIcon from "@mui/icons-material/Cancel";

export function ApprovalTrail({ trail }) {
  if (!trail) return null;

  return (
    <div className="space-y-4">
      {trail.map((step, index) => (
        <div key={index} className="flex items-center space-x-4 p-3 bg-gray-50 rounded border border-gray-200">
          <div className="flex-shrink-0">
            {step.status === "Approved" ? <CheckCircleIcon className="text-green-500" /> :
              step.status === "Disapproved" ? <CancelIcon className="text-red-500" /> :
                <PendingIcon className="text-amber-500" />}
          </div>
          <div className="flex-grow">
            <p className="text-sm font-bold text-gray-700">Level {step.hierarchy}: {step.approverFullName}</p>
            <p className="text-xs text-gray-500">{step.status} {step.actionDate ? `- ${new Date(step.actionDate).toLocaleDateString()}` : ""}</p>
            {step.remarks && <p className="text-xs italic text-blue-600">"{step.remarks}"</p>}
          </div>
        </div>
      ))}
    </div>
  );
}